<template>
  <div id="dataView">
    <div class="box">
      <div class="popup-title">{{device.name}}<i class="el-icon-circle-close close" @click="close"></i></div>
      <div class="data-box">
        <div class="data-lab" v-for="(devAttr,d) in dataList()" :key="d">
            <div v-if="devAttr.accessMode == 'rw'"><p class="attr-name">{{devAttr.name}}</p>&nbsp;:
              <span class="f-r bool" v-if="devAttr.dataType.type == 'bool'">
                  <span class="data-span">{{devAttr.dataType.specs[devAttr.value]}}</span>
                  <span :ref="addref('bool',d)" class="f-r" v-show="$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook&&$store.state.functionList.includes('companyServiceContrl')">
                      <span v-for="(boolObj,b) in devAttr.selectData" :key="b">
                          <el-button v-show="devAttr.value != boolObj.key&&devAttr.value!=null" class="active-btn data-btn" style="top: 0;" @click="changeBool(devAttr,boolObj.key,d)" :title="boolObj.value">{{boolObj.value}}</el-button>
                      </span>
                  </span>
                  <el-button class="active-btn data-btn loading-btn" :loading="true" :ref="addref('boolLoad',d)"></el-button>
              </span>
              <span class="f-r" v-if="devAttr.dataType.type == 'enum'">
                  <span :ref="addref('enumLoadHide',d)">{{devAttr.dataType.specs[devAttr.value]}}</span>
                  <el-select v-model="valueArr[d]" placeholder="请选择" class="enum" @change='changeEnum($event,devAttr,d)' :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook||!$store.state.functionList.includes('companyServiceContrl')">
                      <el-option
                          v-for="enumObj,e in devAttr.selectData"
                          :key="enumObj.e"
                          :label="enumObj.value"
                          :value="enumObj.key">
                      </el-option>
                  </el-select>
              </span>

              <span class="f-r bool" v-if="devAttr.dataType.type == 'int'||devAttr.dataType.type == 'float'||devAttr.dataType.type == 'double'">
                  <span class="data-span f-l" :style="{'color':devAttr.color}">{{devAttr.value==null?'':common.fmoney(devAttr.value,devAttr.dataType.specs.step)}}&nbsp;{{devAttr.dataType.specs.unit}}</span><span :ref="addref('editVal',d)" v-show="$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook&&$store.state.functionList.includes('companyServiceContrl')" class="data-btn m-r-5 active-btn" @click="editAttr(devAttr,d)">设定</span>
                  <el-button class="active-btn f-r data-btn loading-btn" :loading="true" :ref="addref('editValLoad',d)"></el-button>
              </span>
              <span class="f-r bool" v-if="devAttr.dataType.type == 'text'">
                  <span class="data-span f-l" :ref="addref('editTextVal',d)" :style="{'color':devAttr.color}">{{devAttr.value==null?'':devAttr.value}}</span><span :ref="addref('editVal',d)"  v-show="$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook&&$store.state.functionList.includes('companyServiceContrl')" class="data-btn m-r-5 active-btn" @click="editAttr(devAttr,d)">设定</span>
                  <el-button class="active-btn f-r data-btn loading-btn" :loading="true" :ref="addref('editValLoad',d)"></el-button>
              </span>
              <span class="f-r bool" v-if="devAttr.dataType.type == 'date'">
                  <span class="data-span f-l" :ref="addref('editTextVal',d)" :style="{'color':devAttr.color}">{{devAttr.value==null?'':changeTime2(devAttr.value)}}&nbsp;</span><span :ref="addref('editVal',d)"  v-show="$store.state.functionList.includes('companyServiceDevice')&&!$store.state.isLook&&$store.state.functionList.includes('companyServiceContrl')" class="data-btn m-r-5 active-btn" @click="editAttr(devAttr,d)">设定</span >
                  <el-button class="active-btn f-r data-btn loading-btn" :loading="true" :ref="addref('editValLoad',d)"></el-button>
              </span>
            </div>

            <div v-if="devAttr.accessMode == 'r'&&devAttr.dataType.type=='bool'">
                <p class="attr-name">{{devAttr.name}}</p>&nbsp;:
                <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{devAttr.dataType.specs[devAttr.value]}}</span></span>
            </div>
            <div v-if="devAttr.accessMode == 'r'&&devAttr.dataType.type=='enum'">
                <p class="attr-name">{{devAttr.name}}</p>&nbsp;:
                <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{devAttr.dataType.specs[devAttr.value]}}</span></span>
            </div>
            <div v-if="devAttr.accessMode == 'r'&&(devAttr.dataType.type == 'int'||devAttr.dataType.type == 'float'||devAttr.dataType.type == 'double')">
                <p class="attr-name">{{devAttr.name}}</p>&nbsp;:
                <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{devAttr.value==null?'':common.fmoney(devAttr.value,devAttr.dataType.specs.step)}}&nbsp; {{devAttr.dataType.specs.unit}}  </span></span>
            </div>
            <div v-if="devAttr.accessMode == 'r'&&devAttr.dataType.type=='text'">
                <p class="attr-name">{{devAttr.name}}</p>&nbsp;:
                <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{devAttr.value}}</span></span>
            </div>
            <div v-if="devAttr.accessMode == 'r'&&devAttr.dataType.type=='date'">
                <p class="attr-name">{{devAttr.name}}</p>&nbsp;:
                <span class="f-r"><span class="f-r m-r-5" :style="{'color':devAttr.color}">{{changeTime2(devAttr.value)}}</span></span>
            </div>
        </div>
      </div>
      <p class="btn-box b-32"><el-button type="primary" @click="close">关闭</el-button></p>
    </div>
    <div class="popup-editAttr" v-show='editAttrShow'>
        <div class="popup-content">
            <i><i class="el-icon-circle-close close" style="margin-right: 24px;" @click="editAttrShow = false"></i></i>
            <div class="content-top">
                {{nowEditAttr.name}}
            </div>
            <div class="input-box">
                <el-form :model="editAttrForm" :rules="rules" ref="editAttrRef" @submit.native.prevent>
                    <el-form-item prop="editAttrVal" v-if="editAttrForm.type!='date'&&editAttrForm.type!='text'">
                        <el-input class="" v-model="editAttrForm.editAttrVal" @input="editAttrForm.editAttrVal = editAttrForm.editAttrVal.replace(/[^\-?\d.]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^\./g,'').replace(/--/g, '-')"></el-input>
                    </el-form-item>
                    <el-form-item prop="editAttrVal" v-if="editAttrForm.type=='date'">
                        <el-date-picker
                        class="dataTime"
                        v-model="editAttrForm.editAttrVal"
                        type="datetime"
                        value-format='timestamp'
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item prop="editAttrVal" v-if="editAttrForm.type=='text'">
                        <el-input class="" v-model="editAttrForm.editAttrVal"></el-input>
                    </el-form-item>
                </el-form>
                <span class="unit" v-if="nowEditAttr.dataType">{{nowEditAttr.dataType.specs.unit}}</span>
            </div>
            <p class="btn-box b-32"><el-button type="primary" :disabled="!$store.state.functionList.includes('companyServiceDevice')||$store.state.isLook" @click="updateAttr">确定</el-button> <el-button @click="editAttrShow = false">取消</el-button></p>
        </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      var invEditAttr=(rule, value, callback) =>{      //属性定义
          if(!value){
              callback(new Error(`值不能为空`))
          }else{
              let val = Number(value)
              console.log(this.editAttrForm)
              if(this.editAttrForm.type =='date'||this.editAttrForm.type=='text'){
                  callback()
              }else if(Number(this.nowEditAttr.dataType.specs.max)<val||Number(this.nowEditAttr.dataType.specs.min)>val){
                  callback(new Error(`输入值超出范围，范围：${this.nowEditAttr.dataType.specs.min}~${this.nowEditAttr.dataType.specs.max}`));
              }else {
                  callback();
              }
         }
       }
      return{
        valueArr:[],
        nowEditAttr:{},
        nowEditAttrIndex:null,
        editAttrShow:false,
        editAttrForm:{
            editAttrVal:'',
            type:'',
        },
        rules:{     //验证规则
            editAttrVal:[{validator: invEditAttr, required: false, trigger: 'blur'}],
        },
      }
    },
    props:{
      value:{
        type:Array,
        default:{}
      },
      device:{
        type:Object,
        default:{}
      }
    },
    computed:{
      // getValue(){
      //   return (obj)=>{
      //     console.log(obj.identifier,this.value.filter(i=> i.code== obj.identifier)[)
      //   }
      // },
      companyId(){
        return this.$store.state.companyId
      },
      dataList(){
        return ()=>{
          let rwboolArr=[],rwArr=[],rboolArr=[],rArr=[],list=[];
          this.device.properties.forEach(obj=>{
            if(obj.accessMode == 'rw'){
            	if(obj.dataType.type == 'bool'){
            		rwboolArr.push(obj)
            	}else{
            		rwArr.push(obj)
            	}
            }else{
            	if(obj.dataType.type == 'bool'){
            		rboolArr.push(obj)
            	}else{
            		rArr.push(obj)
            	}
            }
          })
          list = list.concat(rwboolArr)
          list = list.concat(rwArr)
          list = list.concat(rboolArr)
          list = list.concat(rArr)
          return list
        }
      },
    },
    methods:{
      changeTime2(now){
        if (now == "" || now == null || typeof now == 'string') {
          return
        }
        now = new Date(Number(now))
        let year = now.getFullYear(); //取得4位数的年份
        let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
        let date = now.getDate(); //返回日期月份中的天数（1到31）
        let hour = now.getHours(); //返回日期中的小时数（0到23）
        let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
        let second = now.getSeconds(); //返回日期中的秒数（0到59）
        if (month < 10) {
          month = "0" + month
        }
        if (date < 10) {
          date = "0" + date
        }
        if (hour < 10) {
          hour = "0" + hour
        }
        if (minute < 10) {
          minute = "0" + minute
        }
        if (second < 10) {
          second = "0" + second
        }
        return `${year+"-"+month+"-"+date} ${hour + ':' + minute+":"+second}`;
      },
      clearArr(){
        this.valueArr = [];
      },
      //动态添加ref
      addref(name,i){
          return name + i
      },
      close(){
        this.$emit('close')
      },
      // 修改颜色
      changeColor(){
          for(let obj of this.device.properties){
              if(obj.dataType.type=='int'||obj.dataType.type=='double'||obj.dataType.type=='float'){
                  obj.color = '#2c3e50'
                  let value = Number(obj.value)
                  if(obj.dataType.warnUp){
                      if(value>=Number(obj.dataType.warnUp)){
                          obj.color = '#ff7e00'
                      }
                  }
                  if(obj.dataType.warnDown){
                      if(value<=Number(obj.dataType.warnDown)){
                          obj.color = '#ff7e00'
                      }
                  }
                  if(obj.dataType.errorUp){
                      if(value>=Number(obj.dataType.errorUp)){
                          obj.color = '#ff0000'
                      }
                  }
                  if(obj.dataType.errorDown){
                      if(value<=Number(obj.dataType.errorDown)){
                          obj.color = '#ff0000'
                      }
                  }
              }
          }
          this.$forceUpdate()
      },
      //打开修改属性值弹窗
      editAttr(obj,i){
          // if(this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
          //     this.functionShow=true;
          //     this.$store.state.mask = true
          //     return
          // }
          this.nowEditAttr = obj;
          this.nowEditAttrIndex = i;
          this.editAttrShow=true
          this.editAttrForm.editAttrVal = this.nowEditAttr.value
          this.editAttrForm.type=this.nowEditAttr.dataType.type
      },
      //修改属性的bool值
      changeBool(obj,val,i){
          // if(this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
          //   this.functionShow=true;
          //   this.$store.state.mask = true
          //   return
          // }
          let loadbtn = 'boolLoad'+i;
          let btn = 'bool'+i;
          this.$refs[btn][0].style.display = 'none'
          this.$refs[loadbtn][0].$el.style.display = 'inline-block'
          let parm = {
              deviceCode:this.device.deviceCode,
              property:obj.identifier,
              value:val,
              companyId:this.companyId
          }
          this.post('/Device/setPropertyValue',parm).then((res)=>{
              if(res.success){
                  this.$message({
                      message: '修改属性成功',
                      type: 'success'
                  });
              }else{
                  this.$message({
                      message: `错误码：${res.result} ${res.message?res.message:''}`,
                      type: 'warning'
                  });
              }
                  this.$refs[btn][0].style.display = 'block'
                  this.$refs[loadbtn][0].$el.style.display = 'none'
          })
      },
      //修改属性的enum值
      changeEnum(val,obj,i){
          // if(this.VerifyArr.includes(12)&&!this.$store.state.isLook&&this.$store.state.functionList.includes('companyServiceDevice')){
          //     this.functionShow=true;
          //     this.$store.state.mask = true
          //     return
          // }
          let parm = {
              deviceCode:this.device.deviceCode,
              property:obj.identifier,
              value:val,
              companyId:this.companyId
          }
          this.post('/Device/setPropertyValue',parm).then((res)=>{
              if(res.success){
                  this.$message({
                      message: '修改属性成功',
                      type: 'success'
                  });
              }else{
                  this.$message({
                      message: `错误码：${res.result} ${res.message?res.message:''}`,
                      type: 'warning'
                  });
              }
          })
      },
      setData(){
         let dev = this.value.filter(i=>i.id==this.device.id)[0]
         if(dev){
           let list = dev.list
           for(let value of list){
             for(let attr of this.device.properties){
               if(value.code == attr.identifier){
                 if(attr.dataType.type=="bool"||attr.dataType.type=="enum"){
                  attr.selectData=[]
                  Object.keys(attr.dataType.specs).forEach(function(key){
                       let devObj ={};
                       devObj.key = key;
                       devObj.value = attr.dataType.specs[key];
                       attr.selectData.push(devObj);
                  });
                 }
                 if(attr.dataType.type!="text"){
                   attr.value = Number(value.value)
                 }else{
                   attr.value = value.value
                 }
               }
             }
           }
           this.changeColor()
         }
      },
      sort(){
        let rwarr=[],warr=[],index = 0;
        for(let properties of this.device.properties){  //筛选属性
          if(properties.accessMode=='rw'){
              if(properties.type=='bool'){
                  rwarr.unshift(properties)
              }else{
                  rwarr.push(properties)
              }
          }else{
              if(properties.type=='bool'){
                  warr.unshift(properties)
              }else{
                  warr.push(properties)
              }
          }
          if(index == this.device.properties.length-1){
              for(let obj of warr){
                  rwarr.push(obj)
              }
            this.device.properties = rwarr
            this.$forceUpdate()
          }
          index++
        }
      },
      //修改属性值
      updateAttr(){
          this.$refs.editAttrRef.validate((valid) => {
              if (valid) {
                  let loadbtn = 'editValLoad'+this.nowEditAttrIndex;
                  let btn = 'editVal'+this.nowEditAttrIndex;
                  this.$refs[btn][0].style.display = 'none'
                  // console.log(this.$refs[btn][0])
                  this.$refs[loadbtn][0].$el.style.display = 'block'
                  this.editAttrShow = false;
                  let parm = {
                      deviceCode:this.device.deviceCode,
                      property:this.nowEditAttr.identifier,
                      value:this.editAttrForm.editAttrVal,
                      companyId:this.companyId
                  }
                  this.post('/Device/setPropertyValue',parm).then((res)=>{
                      if(res.success){
                          this.$message({
                              message: '修改属性成功',
                              type: 'success'
                          });
                      }else{
                          this.$message({
                              message: `错误码：${res.result} ${res.message?res.message:''}`,
                              type: 'warning'
                          });
                      }
                      this.$refs[loadbtn][0].$el.style.display = 'none'
                      this.$refs[btn][0].style.display = 'inline-block'
                  })
              }
          })
      },
    },
    watch:{
      deep: true,
      value(){
        this.setData()
      },
      device(){
        if(this.cssType == 1){
          this.setData()
        }else{
          this.sort()
          setTimeout(()=>{
            this.setData()
          },200)
        }

      },
    }
  }
</script>

<style scoped>

    .m-r-5{
        margin-right: 5px;
    }
  .data-box .data-lab:nth-last-child(1),.data-box .data-lab:nth-last-child(2){
      border-bottom: 1px solid #e6e6e6;
  }
  .data-box-left{
      margin-right: 4%;
  }
  .data-btn{
      max-width: 92px;
      margin: 0 12px;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
  }
  .attr-name{
      float: left;
      max-width: 35%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
  }
  .data-span{
      /* margin: 0 22px 0 12px; */
  }
  .data-span.f-l{
      max-width: 145px;
      margin-right: 0 !important;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
  }
  .active-btn{
      display: inline-block;
      line-height: 14px;
      padding: 6px 12px;
      border-radius: 12px;
      background-color: #5087e4;
      color: #fff;
      position: relative;
      top: 8px;
  }
  .bool>span:last-child{
      margin-right: 5px;
  }
  .data-lab{
    width: 48%;
    text-align: left;
    padding: 0 14px;
    line-height: 48px;
    box-sizing: border-box;
    font-size: 14px;
    border: 1px solid #e6e6e6;
    border-bottom: 0;
  }
  .data-box{
    width: 100%;
    max-height: 477px;
    overflow: auto;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
  }
    .loading-btn{
        width: 54px !important;
        top: 0;
        display: none;
    }
  i.close{
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }
  .popup-title{
    font-size: 16px;
    line-height: 64px;
    margin-bottom: 12px;
    text-align: left;
  }
  .box{
    position: absolute;
    top: 0;
    left: 50%;
    box-sizing: border-box;
    margin-left: -475px;
    width: 958px;
    height: 628px;
    background-color: #fff;
    z-index: 999;
    padding: 0 28px 30px
  }
    .btn-box{
        margin-top: 28px;
        width: 100%;
        text-align: center;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .b-32{
        position: absolute;
        bottom: 22px;
        left: 0;
    }
    .popup-editAttr{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        z-index: 999;
        background-color: rgba(0, 0, 0, .4);
    }
    .popup-content{
        position: absolute;
        top: 50%;
        left: 50%;
        height: 220px;
        padding-left:32px ;
        width: 455px;
        background-color: #fff;
        margin-top: -110px;
        margin-left: -227.5px;
    }
    .content-top{
        text-align: left;
        font-size: 14px;
        margin-top: 45px;
    }
    .input-box{
        width: 392px;
        position: relative;
        margin-top: 12px;
    }
    .unit{
        position: absolute;
        right: 12px;
        font-size: 14px;
        top: 8px;
    }
</style>
<style type="text/css">
  #dataView .el-select.enum .el-input__inner {
      border: 0 !important;
      color: #2c3e50;
      text-align: center;
      width: 100px;
  }
  #dataView .dataTime {
      width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexEdit/mould/dataView.vue